import { render, staticRenderFns } from "./postsDetail.vue?vue&type=template&id=15feb965&scoped=true&"
import script from "./postsDetail.vue?vue&type=script&lang=js&"
export * from "./postsDetail.vue?vue&type=script&lang=js&"
import style0 from "./postsDetail.vue?vue&type=style&index=0&id=15feb965&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15feb965",
  null
  
)

export default component.exports